import { IQuestion } from '../model/ques';
import { E_LocalStorageKey, LocalStorageUtil } from './LocalStorageUtil';

export function getQuestionListFromLocal(): Array<IQuestion> {
  try {
    const questionsStr = LocalStorageUtil.getLocalStorage(
      E_LocalStorageKey.userWaittingForSubmitQuestionQueue,
    );
    if (questionsStr) {
      const qArr = JSON.parse(questionsStr) as Array<IQuestion>;
      return qArr;
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
}

export function setQuestionListToLocal(arr: Array<IQuestion>) {
  try {
    LocalStorageUtil.setLocalStorage(
      E_LocalStorageKey.userWaittingForSubmitQuestionQueue,
      JSON.stringify(arr),
    );
  } catch (e) {
    console.log(e);
  }
}
